import * as React from 'react';
export function AppSidebar() {
    return React.createElement("div", { className: "w-52 bg-gray-900 border-gray-500 border-r" });
}
